export const LOCAL_STORAGE_PREFIX = 'yourduit.netlify.app'
export const LOCAL_STORAGE_SEPARATOR = '|-|'
export const LOCAL_STORAGE_ACTIVITY_KEY_PREFIX = LOCAL_STORAGE_PREFIX + LOCAL_STORAGE_SEPARATOR + 'activity' + LOCAL_STORAGE_SEPARATOR
export const LOCAL_STORAGE_USER_KEY_PREFIX = LOCAL_STORAGE_PREFIX + LOCAL_STORAGE_SEPARATOR + 'user' + LOCAL_STORAGE_SEPARATOR